export default "__VITE_ASSET__81610d17__"